import { useCallback, useEffect, useState } from 'react';
import { API_CORE } from '../../../../../_CORE/API/ApiCORE';
import { SALES_PUBLIC_CONSTANTS as C } from '../_MODULES/SalesApi';

const normalize = (response, fallback) => {
    const status = response?.status ?? response?.code_status ?? 500;
    if (status >= 400 || response?.success === false) throw new Error(response?.message || fallback);
    return response?.data ?? response;
};

export const useSaleProjects = () => {
    const [projects, setProjects] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        setIsLoading(true);
        setError(null);
        try {
            const endpoint = API_CORE.ENDPOINTS[C.PROJECTS_LIST];
            const response = await API_CORE.SERVICES.GET_RESOURCE(endpoint);
            const data = normalize(response, 'No se pudieron cargar los proyectos en venta.');
            const rows = (Array.isArray(data) ? data : [])
                .filter((item) => item?.active !== false && Number(item?.active ?? 1) !== 0)
                .sort((a, b) => Number(a?.sort_order ?? 0) - Number(b?.sort_order ?? 0));
            setProjects(rows);
            return rows;
        } catch (currentError) {
            setProjects([]);
            setError(currentError);
            return [];
        } finally {
            setIsLoading(false);
        }
    }, []);

    const submitOrder = useCallback(async (formData) => {
        const endpoint = API_CORE.ENDPOINTS[C.ORDER_CREATE];
        const response = await API_CORE.SERVICES.POST_RESOURCE(endpoint, formData);
        return normalize(response, 'No se pudo enviar el comprobante.');
    }, []);

    useEffect(() => { load(); }, [load]);

    return { projects, isLoading, error, reload: load, submitOrder };
};
